import axios from 'axios';
import { getToken } from './authServices';

const apiUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const authToken = getToken();
        if (authToken) {
            config.headers.Authorization = authToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401 && window.location.pathname !== '/admin/login') {
            localStorage.removeItem('token')
            return window.location.replace(process.env.REACT_APP_BASE_PATH + '/admin/login');
        }
        if (error.response && error.response.status === 404) {
            return error.response;
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
